module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wipes@2x_f7023d.png";